import React from 'react';

import type { ThemeSpacing } from '@rover/kibble/styles';
import { themeGet, useTheme } from '@rover/kibble/utils';

import Box from '../Box';
import type {
  BackgroundSystemsProps,
  BorderSystemProps,
  ColorSystemProps,
  FlexboxSystemProps,
  LayoutSystemProps,
  PositionSystemsProps,
  SpacingSystemProps,
} from '../styledSystemPropTypes';

export type Props = BackgroundSystemsProps &
  BorderSystemProps &
  ColorSystemProps &
  FlexboxSystemProps &
  LayoutSystemProps &
  PositionSystemsProps &
  SpacingSystemProps & {
    gap?: ThemeSpacing;
    children: any;
    testID?: string;
  };

function Flex({ gap, children, ...props }: Props): any {
  // use flex gap hack here: https://codyhouse.co/nuggets/flex-gap-using-negative-margins
  const elements = React.Children.toArray(children);
  const theme = useTheme();

  if (elements.length <= 1 || !gap) {
    return (
      <Box display="flex" {...props}>
        {elements}
      </Box>
    );
  }

  const gapValue = themeGet(
    `space.${gap}`,
    gap
  )({
    theme,
  });
  const parentGapVal = `-${gapValue}`;
  return (
    // @ts-ignore: use custom ml, mb
    <Box display="flex" ml={parentGapVal} mb={parentGapVal} {...props}>
      {elements.map((element) =>
        React.cloneElement(element, {
          style: {
            marginLeft: gapValue,
            marginBottom: gapValue,
          },
        })
      )}
    </Box>
  );
}

export default Flex;



// WEBPACK FOOTER //
// ../kibble/components/Flex/Flex.tsx